import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const names = ['María', 'Laura', 'Sofía', 'Valentina', 'Camila', 'Lucía', 'Martina'];
const locations = ['Córdoba', 'Buenos Aires', 'Rosario', 'Mendoza', 'CABA', 'Neuquén'];
export const PurchaseToast = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    location: '',
    time: 0
  });
  useEffect(() => {
    // Diferimos toda la lógica del toast hasta que el browser esté idle.
    let initialTimer: ReturnType<typeof setTimeout> | undefined;
    const idle = (window as any).requestIdleCallback || ((cb: () => void) => setTimeout(cb, 500));
    const handle = idle(() => {
      initialTimer = setTimeout(() => {
        showNewToast();
      }, 5000);
    });
    return () => {
      if (initialTimer) clearTimeout(initialTimer);
      if ((window as any).cancelIdleCallback && typeof handle === 'number') {
        ;
        (window as any).cancelIdleCallback(handle);
      }
    };
  }, []);
  const showNewToast = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomLocation = locations[Math.floor(Math.random() * locations.length)];
    const randomTime = Math.floor(Math.random() * 59) + 1;
    setData({
      name: randomName,
      location: randomLocation,
      time: randomTime
    });
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next toast between 15-30 seconds
      const nextDelay = Math.floor(Math.random() * 15000) + 15000;
      setTimeout(showNewToast, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-251">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-xl shadow-2xl border border-stone-100 p-4 max-w-sm flex items-start gap-3" data-id="element-252">
          <div className="bg-green-100 text-green-600 rounded-full p-1 shrink-0 mt-0.5" data-id="element-253">
            <CheckCircleIcon className="w-5 h-5" data-id="element-254" />
          </div>
          <div data-id="element-255">
            <p className="text-sm text-stone-900" data-id="element-256">
              <span className="font-bold" data-id="element-257">{data.name}</span> de {data.location}{' '}
              acaba de comprar.
            </p>
            <p className="text-xs text-stone-500 mt-1" data-id="element-258">
              Hace {data.time} minutos • Compra Verificada
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};